module.exports = __webpack_public_path__ + "static/media/about-us-1.5883ae62.png";